import request from '@/config/axios'

export interface CapacityDashboardSummary {
  todayFeeTotal?: number
  todayCompletedCount?: number
  todayCreatedCount?: number
  todayCancelledCount?: number
  processingCount?: number
  stuckTodoCount?: number
  onlineRiderCount?: number
  approvedCertCount?: number
  pendingCertCount?: number
  activeOrgCount?: number
  pendingOrgApplyCount?: number
  openPenaltyReviewCount?: number
  pendingAppealCount?: number
}

export interface CapacityDashboardTrend {
  dates?: string[]
  feeTotal?: number[]
  completedCount?: number[]
}

export const getCapacityDashboardSummary = () => {
  return request.get<CapacityDashboardSummary>({ url: '/capacity/platform/dashboard/summary' })
}

export const getCapacityDashboardTrend = () => {
  return request.get<CapacityDashboardTrend>({ url: '/capacity/platform/dashboard/trend' })
}
